import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_CIRCLE } from "@/theme/tokens";
import Button from "@/theme/Button";

const LINKS = [];

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-md"
      style={{
        background: "rgba(6,6,6,0.75)",
        borderBottom: "1px solid rgba(255,255,255,0.10)",
      }}
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-3"
          onClick={() => setOpen(false)}
        >
          <img
            src={LOGO_CIRCLE}
            alt="Glitch Game Labs"
            className="w-9 h-9 rounded-full object-cover"
            style={{ background: "#fff" }}
          />
          <span
            className="hidden sm:inline font-black text-xs tracking-[0.3em] uppercase text-white"
            style={{ fontFamily: "'Azeret Mono', monospace" }}
          >
            Glitch<span style={{ color: "#c8ff2a" }}>/</span>Game Labs
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `font-mono text-[11px] tracking-[0.28em] uppercase transition-colors ${
                  isActive ? "text-[#c8ff2a]" : "text-white/70 hover:text-white"
                }`
              }
              style={{ fontFamily: "'JetBrains Mono', monospace" }}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button
            as={Link}
            to="/contact"
            size="sm"
            data-testid="header-cta"
            onClick={() => setOpen(false)}
          >
            Start a project
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden px-5 py-4 flex flex-col gap-3"
          style={{
            background: "#060606",
            borderTop: "1px solid rgba(255,255,255,0.10)",
          }}
        >
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `font-mono text-[12px] tracking-[0.28em] uppercase ${
                  isActive ? "text-[#c8ff2a]" : "text-white/70"
                }`
              }
              style={{ fontFamily: "'JetBrains Mono', monospace" }}
            >
              {l.label}
            </NavLink>
          ))}
          <Button
            as={Link}
            to="/contact"
            size="sm"
            className="mt-2 self-start"
            onClick={() => setOpen(false)}
          >
            Start a project
          </Button>
        </div>
      )}
    </header>
  );
};

export default Header;
